import React from 'react';

interface TwitterIconProps {
  size?: number;
  className?: string;
}

const TwitterIcon: React.FC<TwitterIconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M11.5898 2.40007H13.4897L9.33888 7.1442L14.222 13.5999H10.3986L7.40389 9.68456L3.97732 13.5999H2.07622L6.51594 8.52552L1.83154 2.40007H5.75206L8.45897 5.97885L11.5898 2.40007ZM10.9229 12.4627H11.9757L5.18001 3.47755H4.05026L10.9229 12.4627Z" 
        fill="currentColor"
      />
    </svg>
  );
};

export default TwitterIcon;